import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76849d50")

_pushScopeId("data-v-76849d50")
const _hoisted_1 = {
  class: "login-form-wrapper grid-content p-15 p-lg-20 mx-auto",
  style: {"flex-direction":"column"}
}
const _hoisted_2 = { style: {"padding":"30px 0","text-align":"center"} }
const _hoisted_3 = { class: "mb-13" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "text-gray-400 fw-bold fs-5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "login-date" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fs-3 bi bi-lock" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = { class: "login-date" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fs-3 bi bi-clock-history" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = { class: "text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.dynamicAsset,
        alt: `${_ctx.ASSETS_CLIENT_NAME}_brand_logo.png`,
        style: [{ width: _ctx.ASSETS_CLIENT_NAME === 'hermelin' ? '80%' : '100%' }, { height: _ctx.ASSETS_CLIENT_NAME === 'hermelin' ? 'auto' : '200px' }]
      }, null, 12, ["src", "alt"])
    ]),
    _createVNode(_component_el_container, { class: "position-relative" }, {
      default: _withId(() => [
        _createVNode(_component_InnerLoader, {
          loading: _ctx.loading,
          innerLoading: true
        }, null, 8, ["loading"]),
        _createVNode(_component_el_main, null, {
          default: _withId(() => [
            _createVNode(_component_el_form, {
              rules: _ctx.rules,
              model: _ctx.loginData,
              ref: "loginForm"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_3, [
                  _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('message.WELCOME_BACK')), 1),
                  _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('message.SIGN_IN_TO_YOUR_ACCOUNT')), 1),
                  (_ctx.session_div)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode("div", _hoisted_8, [
                          _createVNode("p", null, [
                            _hoisted_9,
                            _hoisted_10,
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('message.LOGIN_DATE')) + ":", 1)
                          ]),
                          _createVNode("p", null, _toDisplayString(_ctx.login_date), 1)
                        ]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("p", null, [
                            _hoisted_12,
                            _hoisted_13,
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('message.LAST_SESSION_DURATION')), 1)
                          ]),
                          _createVNode("p", null, _toDisplayString(_ctx.session_duration), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("a", {
                    href: _ctx.sso_url,
                    type: "button",
                    class: "btn btn-lg btn-primary w-100 mb-5"
                  }, _toDisplayString(_ctx.$t('message.LOGIN_TO_CONTINUE')), 9, ["href"])
                ])
              ]),
              _: 1
            }, 8, ["rules", "model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})